document.addEventListener("DOMContentLoaded", () => {

  /* ===========================
     Scroll Reveal Animation
  =========================== */

  const revealItems = document.querySelectorAll(".kk-reveal");

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("kk-visible");
      }
    });
  }, {
    threshold: 0.15
  });

  revealItems.forEach(item => revealObserver.observe(item));


  /* ===========================
     Animated Counters
  =========================== */

  const counters = document.querySelectorAll(".kk-counter");

  const counterObserver = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (!entry.isIntersecting) return;

      const counter = entry.target;

      const target = parseInt(counter.dataset.count);

      const suffix = counter.dataset.suffix || "";

      let current = 0;

      const increment = Math.ceil(target / 120);

      const timer = setInterval(() => {

        current += increment;

        if (current >= target) {

          current = target;

          clearInterval(timer);

        }

        counter.textContent = current.toLocaleString() + suffix;

      }, 16);

      counterObserver.unobserve(counter);

    });

  });

  counters.forEach(counter => counterObserver.observe(counter));


  /* ===========================
     Luxury Hover Lift
  =========================== */

  document.querySelectorAll(".kk-card").forEach(card => {

    card.addEventListener("mouseenter", () => {

      card.style.transform = "translateY(-12px)";

    });

    card.addEventListener("mouseleave", () => {

      card.style.transform = "";

    });

  });


  /* ===========================
     Smooth Anchor Scrolling
  =========================== */

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {

    anchor.addEventListener("click", function(e){

      const target = document.querySelector(this.getAttribute("href"));

      if(target){

        e.preventDefault();

        target.scrollIntoView({

          behavior:"smooth",

          block:"start"

        });

      }

    });

  });
/* =========================================================
   KUTTY KUTZ MEMBERSHIP PORTAL INTERACTIONS
   ========================================================= */

(() => {
  "use strict";

  if (window.KKMembershipPortalReady) return;
  window.KKMembershipPortalReady = true;

  function getApplicationFields() {
    return {
      plan: document.querySelector("#KKMembershipSelectedPlan"),
      term: document.querySelector("#KKMembershipSelectedTerm"),
      form: document.querySelector("#KKMembershipApplication")
    };
  }

  function setSelectValue(select, value) {
    if (!select || !value) return;

    const matchingOption = Array.from(select.options).find(
      (option) =>
        option.value.trim().toLowerCase() === value.trim().toLowerCase()
    );

    if (matchingOption) {
      select.value = matchingOption.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function saveSelectedPrice(form, price) {
    if (!form || !price) return;

    let priceInput = form.querySelector(
      'input[name="contact[Selected Price]"]'
    );

    if (!priceInput) {
      priceInput = document.createElement("input");
      priceInput.type = "hidden";
      priceInput.name = "contact[Selected Price]";
      form.appendChild(priceInput);
    }

    priceInput.value = price;
  }

  function selectMembershipOption(button) {
    const card = button.closest(".kk-membership-plan-card");
    const fields = getApplicationFields();

    if (!card) return;

    card
      .querySelectorAll(".kk-membership-price-option")
      .forEach((option) => {
        option.classList.remove("is-selected");
        option.setAttribute("aria-pressed", "false");
      });

    button.classList.add("is-selected");
    button.setAttribute("aria-pressed", "true");

    const plan = button.dataset.plan || "";
    const term = button.dataset.term || "";
    const price = button.dataset.price || "";

    setSelectValue(fields.plan, plan);
    setSelectValue(fields.term, term);
    saveSelectedPrice(fields.form, price);

    card.dataset.selectedPlan = plan;
    card.dataset.selectedTerm = term;
    card.dataset.selectedPrice = price;
  }

  function prepareMembershipApplication(link) {
    const card = link.closest(".kk-membership-plan-card");
    const fields = getApplicationFields();

    if (!card) return;

    let selectedOption = card.querySelector(
      ".kk-membership-price-option.is-selected"
    );

    if (!selectedOption) {
      selectedOption = card.querySelector(".kk-membership-price-option");
    }

    if (selectedOption) {
      selectMembershipOption(selectedOption);
    } else {
      setSelectValue(fields.plan, link.dataset.plan || "");
    }

    window.requestAnimationFrame(() => {
      document.querySelector("#kk-membership-apply")?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }

  function togglePolicies(button) {
    const portal = button.closest(".kk-membership-portal");
    const panel = portal?.querySelector("[data-membership-policies]");

    if (!panel) return;

    const isOpening = panel.hasAttribute("hidden");

    if (isOpening) {
      panel.removeAttribute("hidden");
      button.textContent = "Hide Policies";
      button.setAttribute("aria-expanded", "true");
    } else {
      panel.setAttribute("hidden", "");
      button.textContent = "View Policies";
      button.setAttribute("aria-expanded", "false");
    }
  }

  document.addEventListener("click", (event) => {
    const priceOption = event.target.closest(
      ".kk-membership-price-option"
    );

    if (priceOption) {
      event.preventDefault();
      selectMembershipOption(priceOption);
      return;
    }

    const membershipLink = event.target.closest(
      "[data-membership-select]"
    );

    if (membershipLink) {
      event.preventDefault();
      prepareMembershipApplication(membershipLink);
      return;
    }

    const policyButton = event.target.closest(
      "[data-membership-policies-toggle]"
    );

    if (policyButton) {
      event.preventDefault();
      togglePolicies(policyButton);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".kk-membership-price-option")
      .forEach((button) => {
        button.setAttribute("aria-pressed", "false");
      });

    document
      .querySelectorAll("[data-membership-policies-toggle]")
      .forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
  });
})();
});